import Iconify from 'src/components/Iconify';
import { Badge } from 'src/@/components/ui/badge';
import { Switch } from 'src/@/components/ui/switch';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from 'src/@/components/ui/table';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from 'src/@/components/ui/tooltip';

import { MAKE_DESIGN as d } from '../Make.design';

export default function TableMakeCredentials({ data, onEdit, onDelete, changeStatus }) {
    if (!data || data.length === 0) {
        return (
            <div className={d.table.container}>
                <div className={d.emptyState.container}>
                    <div className={d.emptyState.iconBox}>
                        <Iconify icon="eva:link-2-outline" width={28} className="text-gray-400" />
                    </div>
                    <p className={d.emptyState.title}>Nenhuma credencial encontrada</p>
                    <p className={d.emptyState.subtitle}>
                        Crie uma nova credencial para começar a integrar com o Make.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className={d.table.container}>
            <Table>
                <TableHeader>
                    <TableRow className={d.table.header}>
                        <TableHead className="w-[220px]">Nome</TableHead>
                        <TableHead>URL</TableHead>
                        <TableHead className="w-[100px]">Status</TableHead>
                        <TableHead className="w-[100px] text-right">Ações</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row._id} className={d.table.row}>
                            <TableCell>
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-lg bg-[#7C3AED]/10 flex items-center justify-center flex-shrink-0">
                                        <Iconify icon="eva:link-2-outline" width={16} className="text-[#7C3AED]" />
                                    </div>
                                    <span className={d.table.cellName}>{row.keys?.name}</span>
                                </div>
                            </TableCell>
                            <TableCell>
                                <span className={d.table.cellUrl}>{row.keys?.url}</span>
                            </TableCell>
                            <TableCell>
                                <div className="flex items-center gap-2">
                                    <Switch
                                        checked={row.status}
                                        onCheckedChange={(value) => changeStatus(row, value)}
                                    />
                                    <Badge
                                        variant="outline"
                                        className={`text-xs font-medium flex items-center gap-1.5 ${
                                            row.status
                                                ? 'bg-green-50 text-green-700 border-green-200'
                                                : 'bg-gray-50 text-gray-500 border-gray-200'
                                        }`}
                                    >
                                        <span
                                            className={`w-1.5 h-1.5 rounded-full ${
                                                row.status ? 'bg-green-500' : 'bg-gray-400'
                                            }`}
                                        />
                                        {row.status ? 'Ativo' : 'Inativo'}
                                    </Badge>
                                </div>
                            </TableCell>
                            <TableCell>
                                <div className={`${d.table.actions} justify-end`}>
                                    <TooltipProvider>
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <button
                                                    onClick={() => onEdit(row)}
                                                    className={`${d.table.actionButton} ${d.table.editButton}`}
                                                >
                                                    <Iconify icon="eva:edit-2-outline" width={16} />
                                                </button>
                                            </TooltipTrigger>
                                            <TooltipContent>Editar</TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>
                                    <TooltipProvider>
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <button
                                                    onClick={() => onDelete(row)}
                                                    className={`${d.table.actionButton} ${d.table.deleteButton}`}
                                                >
                                                    <Iconify icon="eva:trash-2-outline" width={16} />
                                                </button>
                                            </TooltipTrigger>
                                            <TooltipContent>Excluir</TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}
